// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Modal/Modal.bs.js";
import * as Button$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Button/Button.bs.js";
import * as Modal__Close$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Modal/Modal__Close.bs.js";
import * as Theme__Color$PrezzeeRibbon from "@prezzee/ribbon/src/theme/Theme__Color.bs.js";
import * as Modal__Container$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Modal/Modal__Container.bs.js";

var buttonColour_0 = Theme__Color$PrezzeeRibbon.Common.prezzeeRed;

var buttonColour_1 = Theme__Color$PrezzeeRibbon.Business.white;

var buttonColour_2 = Theme__Color$PrezzeeRibbon.Common.darkRed;

var buttonColour = /* Custom */{
  _0: buttonColour_0,
  _1: buttonColour_1,
  _2: buttonColour_2
};

var modalContainer = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(387)),
      tl: {
        hd: BsCss.outline(BsCss.px(1), "solid", "transparent"),
        tl: /* [] */0
      }
    });

var modalInnerContainer = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme__Color$PrezzeeRibbon.Common.white),
      tl: {
        hd: BsCss.boxShadow(Css_Legacy_Core.Shadow.box(BsCss.px(0), BsCss.px(40), BsCss.px(200), undefined, undefined, BsCss.rgba(0, 0, 0, BsCss.pct(8)))),
        tl: {
          hd: BsCss.borderRadius(BsCss.px(4)),
          tl: {
            hd: BsCss.textAlign("center"),
            tl: {
              hd: BsCss.paddingTop(BsCss.px(50)),
              tl: {
                hd: BsCss.paddingBottom(BsCss.px(30)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var modalHeading = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(28)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(42)),
        tl: {
          hd: BsCss.fontWeight({
                NAME: "num",
                VAL: 600
              }),
          tl: {
            hd: BsCss.color(Theme__Color$PrezzeeRibbon.Business.charcoal),
            tl: /* [] */0
          }
        }
      }
    });

var modalText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(24)),
        tl: {
          hd: BsCss.fontWeight({
                NAME: "num",
                VAL: 400
              }),
          tl: {
            hd: BsCss.paddingTop(BsCss.px(18)),
            tl: {
              hd: BsCss.paddingBottom(BsCss.px(22)),
              tl: {
                hd: BsCss.width(BsCss.pct(70)),
                tl: {
                  hd: BsCss.margin("auto"),
                  tl: {
                    hd: BsCss.color(Theme__Color$PrezzeeRibbon.Business.bodyTextGrey),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var modalButton = Curry._1(BsCss.style, {
      hd: BsCss.display("block"),
      tl: {
        hd: BsCss.margin("auto"),
        tl: {
          hd: BsCss.width(BsCss.pct(90)),
          tl: /* [] */0
        }
      }
    });

var modalLink = Curry._1(BsCss.style, {
      hd: BsCss.textDecoration("underline"),
      tl: /* [] */0
    });

var modalClose = Curry._1(BsCss.style, {
      hd: BsCss.important(BsCss.background(BsCss.hex("EBEBEB"))),
      tl: {
        hd: BsCss.important(BsCss.right(BsCss.px(11))),
        tl: {
          hd: BsCss.important(BsCss.top(BsCss.px(11))),
          tl: {
            hd: BsCss.important(BsCss.fontSize(BsCss.px(20))),
            tl: {
              hd: BsCss.borderRadius(BsCss.pct(50)),
              tl: {
                hd: BsCss.width(BsCss.px(30)),
                tl: {
                  hd: BsCss.height(BsCss.px(30)),
                  tl: {
                    hd: BsCss.important(BsCss.color(BsCss.hex("444444"))),
                    tl: {
                      hd: BsCss.display("flex"),
                      tl: {
                        hd: BsCss.justifyContent("center"),
                        tl: {
                          hd: BsCss.alignItems("center"),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  modalContainer: modalContainer,
  modalInnerContainer: modalInnerContainer,
  modalHeading: modalHeading,
  modalText: modalText,
  modalButton: modalButton,
  modalLink: modalLink,
  modalClose: modalClose
};

var content = JsxRuntime.jsx(React.Fragment, {
      children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                    children: "Start gifting today!",
                    className: modalHeading
                  }),
              JsxRuntime.jsx("p", {
                    children: "Sign up to Prezzee Business to start purchasing your gift cards.",
                    className: modalText
                  }),
              JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                    children: JsxRuntime.jsx(Link, {
                          href: "/business/register/",
                          prefetch: false,
                          children: JsxRuntime.jsx("button", {
                                children: "Create an account",
                                className: modalButton
                              })
                        }),
                    colour: /* BusinessPurple */3,
                    variant: /* Small */1
                  }),
              JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                    children: JsxRuntime.jsx(Link, {
                          href: "/business/signin/",
                          prefetch: false,
                          children: JsxRuntime.jsx("button", {
                                children: "Or, log in here",
                                className: modalLink
                              })
                        }),
                    fill: /* None */2,
                    colour: buttonColour
                  })
            ],
            className: modalInnerContainer
          })
    });

var ModalContent = {
  content: content
};

function CatalogueModal(props) {
  var onRequestClose = props.onRequestClose;
  return JsxRuntime.jsx(Modal$PrezzeeRibbon.make, {
              children: JsxRuntime.jsxs(Modal__Container$PrezzeeRibbon.make, {
                    id: "modal-container",
                    isOpen: props.modalOpen,
                    onRequestClose: onRequestClose,
                    children: [
                      JsxRuntime.jsx(Modal__Close$PrezzeeRibbon.make, {
                            className: modalClose,
                            closeFunc: (function (param) {
                                Curry._1(onRequestClose, undefined);
                              })
                          }),
                      content
                    ],
                    borderless: true,
                    className: modalContainer
                  })
            });
}

var Link$1;

var make = CatalogueModal;

export {
  Link$1 as Link,
  buttonColour ,
  Styles ,
  ModalContent ,
  make ,
}
/* modalContainer Not a pure module */
